import { defineMessages } from 'react-intl';

export const paymentPauseMessages = defineMessages({
  Label: {
    id: 'ic-atom-PaymentPause-label',
    defaultMessage:
      'Ich möchte die {brand}-Zahlpause nutzen & zahle erst in 4 Monaten<hint>*</hint>',
  },
});
